import React, { useState, useEffect } from "react";
import Banner from "../Pages/Banner";
import Header from "../header";
import Footer from "../Footer";
import TechnologyPartners from "./techPartners";
import { Container } from "react-bootstrap";

function ContactUs(props) {
    const [mobile, setMobile] = useState(false);

    useEffect(() => {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            setMobile({ mobile: true });
        }
    }, []);

    return (
        <div>
            <Header />
            <Banner checkPricing={true} btn_show={true} heading={"TECHNOLOGY PARTNERS"} />
            <Container>
                <div className="overview-paragraph">
                    <p className={!mobile ? "text-left border-p-left" : "border-p-left p-0"}>
                        Technology partners typically develop software that is delivered as a service. This software
                        stores sensitive data or requires high security or compliance. They also need the flexibility
                        and scalability of the cloud to control costs and deploy in more of a “just in time” fashion.
                        DETASAD provides the simplest, cost effective solution for our technology partners to offer a
                        secure and compliant version of their products.
                    </p>
                </div>
                <TechnologyPartners />
            </Container>
            <Footer />
        </div>
    );
}

export default ContactUs;
